import type {ProductAnnouncementProps} from '@github-ui/product-announcement/components/ProductAnnouncement'
import type {
  ProductAnnouncementBannerEvent,
  ProductAnnouncementModalEvent,
} from '@github-ui/product-announcement/components/ProductAnnouncement.types'

export const getProductAnnouncementId = ({
  needsOnboarding = false,
}: {
  needsOnboarding?: boolean
} = {}): ProductAnnouncementProps['announcementId'] => {
  if (needsOnboarding) return 'ccaOnboarding'

  return ''
}

export const handleProductAnnouncementBannerTracking = (
  _productAnnouncementId: ReturnType<typeof getProductAnnouncementId>,
  _event: ProductAnnouncementBannerEvent,
) => {
  void _productAnnouncementId
  void _event
}

export const handleProductAnnouncementModalTracking = (
  _productAnnouncementId: ReturnType<typeof getProductAnnouncementId>,
  _event: ProductAnnouncementModalEvent,
  _data?: Record<string, unknown>,
) => {
  void _productAnnouncementId
  void _event
  void _data
}
